module.exports = __webpack_public_path__ + "img/0-sm.a84ce38e.jpg";